export default __webpack_public_path__ + "static/media/bg_bank_login.f17ff9ef.png";